import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
export class OptionalConsentsResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.id = 0;
        this.label = "";
        this.description = "";
        this.accepted = false;
    }
    pk() {
        return this.id.toString();
    }
}
OptionalConsentsResource.urlRoot = apiResourceUrl("consents/optional");
//# sourceMappingURL=OptionalConsentsResource.js.map